module.exports = __webpack_public_path__ + "static/media/WhitneyCond-Bold.1f44529a.otf";